import React from "react";
import { PostData, UploadURL } from "../../api/service";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  Typography,
  Avatar,
} from "@material-ui/core";
import { Link } from "react-router-dom";
export default function RegistrationsTable() {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [total, setTotal] = React.useState(0);

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(0); // 0-based for MUI

  function loadData() {
    PostData(`/nss/students-paginated`, { page: page + 1, limit }).then(
      (response) => {
        // Assume response is { data: [...], total: number }
        setData(response.data || []);
        setTotal(response.total || 0);
        setIsLoaded(true);
      },
    );
  }

  React.useEffect(() => {
    loadData();
  }, [page, limit]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const columns = [
    { id: "id", label: "ID", minWidth: 50 },
    { id: "student_name", label: "Student Name", minWidth: 150 },
    { id: "roll_no", label: "Roll No", minWidth: 100 },
    { id: "email", label: "Email", minWidth: 200 },
    { id: "course", label: "Course", minWidth: 150 },
    { id: "department", label: "Department", minWidth: 150 },
    { id: "registration_date", label: "Registration Date", minWidth: 120 },
    { id: "view", label: "View", minWidth: 100 },
  ];

  return (
    <Paper>
      <Typography variant="h6" style={{ padding: 16 }}>
        NSS Student Registrations
      </Typography>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                {columns.map((column) => {
                  const value = row[column.id];
                  return (
                    <TableCell key={column.id}>
                      {column.id === "student_name" ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            src={`${UploadURL}${row.photo}`}
                            style={{ marginRight: 8 }}
                          />
                          {value}
                        </div>
                      ) : column.id === "view" ? (
                        <Link to={`/registrations/${row.id}`}>View</Link>
                      ) : (
                        value
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={total}
        rowsPerPage={limit}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
